(function () {
  'use strict';

  const registry = window.__onverCustomWizard || {
    initialized: new WeakSet(),
    controllers: new Set(),
    listenersInstalled: false
  };
  window.__onverCustomWizard = registry;

  const pendingLifetime = 30 * 60 * 1000;
  const storedTypes = new Set(['text', 'email', 'tel', 'url', 'search', 'number', 'textarea', 'select-one', 'radio', 'checkbox']);

  function storedControls(form) {
    return Array.from(form.elements).filter(function (field) {
      return !field.disabled && storedTypes.has(field.type)
        && /^contact\[[^\[\]\r\n]{1,100}\]$/.test(field.name)
        && !/token|nonce|captcha|authenticity/i.test(field.name)
        && field.name !== 'contact[Design summary]';
    });
  }

  function clearPendingRequest(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {}
  }

  function savePendingRequest(form, key) {
    clearPendingRequest(key);
    try {
      const fields = storedControls(form).map(function (field) {
        const record = { name: field.name, type: field.type, value: field.value };
        if (field.type === 'radio' || field.type === 'checkbox') record.checked = field.checked;
        return record;
      });
      if (fields.length > 64 || fields.some(function (field) { return field.value.length > 4000; })) return;
      const serialized = JSON.stringify({ version: 1, savedAt: Date.now(), fields: fields });
      if (serialized.length <= 32768) window.sessionStorage.setItem(key, serialized);
    } catch (error) {}
  }

  function restorePendingRequest(form, key) {
    try {
      const serialized = window.sessionStorage.getItem(key);
      if (!serialized || serialized.length > 32768) return;
      const saved = JSON.parse(serialized);
      if (!saved || saved.version !== 1 || !Number.isFinite(saved.savedAt)) return;
      const age = Date.now() - saved.savedAt;
      if (age < 0 || age > pendingLifetime || !Array.isArray(saved.fields) || saved.fields.length > 64) return;
      const valid = saved.fields.every(function (record) {
        return record && typeof record === 'object'
          && typeof record.name === 'string' && record.name.length <= 109
          && typeof record.type === 'string' && storedTypes.has(record.type)
          && typeof record.value === 'string' && record.value.length <= 4000
          && ((record.type !== 'radio' && record.type !== 'checkbox') || typeof record.checked === 'boolean');
      });
      if (!valid) return;
      const controls = storedControls(form);
      saved.fields.forEach(function (record) {
        controls.filter(function (field) {
          return field.name === record.name && field.type === record.type;
        }).forEach(function (field) {
          if (field.type === 'radio' || field.type === 'checkbox') {
            if (field.value === record.value) field.checked = record.checked;
          } else if (field.type === 'select-one') {
            if (Array.from(field.options).some(function (option) { return option.value === record.value; })) {
              field.value = record.value;
            }
          } else if (!(field.maxLength >= 0 && record.value.length > field.maxLength)) {
            field.value = record.value;
          }
        });
      });
    } catch (error) {
    } finally {
      clearPendingRequest(key);
    }
  }

  function initialize(root) {
    if (registry.initialized.has(root)) return;

    const form = root.querySelector('#OnverCustomForm');
    if (!form) return;
    const pendingKey = 'onver:custom-request:v1:' + window.location.pathname;
    const success = form.querySelector('.oc-success');
    if (success || form.dataset.success === 'true') {
      clearPendingRequest(pendingKey);
      registry.initialized.add(root);
      if (success) {
        if (!success.hasAttribute('tabindex')) success.setAttribute('tabindex', '-1');
        success.focus({ preventScroll: true });
      }
      return;
    }

    const panels = Array.from(form.querySelectorAll('[data-step]'))
      .filter(function (panel) { return /^[1-4]$/.test(panel.dataset.step); })
      .sort(function (a, b) { return Number(a.dataset.step) - Number(b.dataset.step); });
    if (panels.length !== 4) return;

    registry.initialized.add(root);

    const progress = root.querySelector('#oc-progress');
    const progressBar = root.querySelector('#oc-progress-bar');
    const submit = form.querySelector('#oc-submit');
    const submitLabel = submit && (submit.querySelector('[data-submit-label]') || submit);
    const originalSubmitContent = submitLabel ? Array.from(submitLabel.childNodes) : [];
    const inspiration = form.querySelector('#oc-inspiration');
    const summary = form.querySelector('#oc-request-summary');
    const phone = form.querySelector('#oc-phone');
    const serverError = form.querySelector('.oc-form-error');
    if (serverError) restorePendingRequest(form, pendingKey);
    else clearPendingRequest(pendingKey);
    const emptyLabel = root.dataset.emptyLabel || 'Open to guidance';
    const stepLabel = (progress && progress.dataset.stepLabel)
      || root.dataset.stepLabel || 'Step {current} of {total}';
    const originalOptions = inspiration
      ? Array.from(inspiration.options).map(function (option) {
        return { option: option, disabled: option.disabled, hidden: option.hidden };
      }) : [];
    let currentStep = 1;
    let submitting = false;
    let submitLabelChanged = false;

    form.noValidate = true;
    root.classList.add('oc-enhanced');

    root.querySelectorAll('[data-next], [data-back], [data-edit], [data-step-trigger]')
      .forEach(function (button) {
        if (button.tagName === 'BUTTON') button.type = 'button';
      });

    function getField(id) {
      return form.querySelector('#' + id);
    }

    function fieldValue(id) {
      const field = getField(id);
      if (!field || field.disabled) return '';
      return String(field.value || '').trim();
    }

    function selectedText(id) {
      const field = getField(id);
      if (!field || !field.value || field.disabled) return '';
      const option = field.options && field.options[field.selectedIndex];
      return option ? option.textContent.trim() : fieldValue(id);
    }

    function selectedRadio(name) {
      const radio = Array.from(form.elements).find(function (field) {
        return field.name === name && field.type === 'radio' && field.checked && !field.disabled;
      });
      return radio ? radio.value.trim() : '';
    }

    function selectedType() {
      return selectedRadio('contact[Jewelry type]');
    }

    function typeForReview() {
      const type = selectedType();
      const otherPiece = fieldValue('oc-other-piece');
      return type === 'Other' && otherPiece ? type + ' — ' + otherPiece : type;
    }

    function synchronizeInspiration() {
      const type = selectedType();
      if (inspiration) {
        originalOptions.forEach(function (item) {
          const requiredType = item.option.dataset.type || 'any';
          const incompatible = Boolean(type && requiredType !== 'any' && requiredType !== type);
          item.option.disabled = item.disabled || incompatible;
          item.option.hidden = item.hidden || incompatible;
        });
        const selected = inspiration.options[inspiration.selectedIndex];
        if (!selected || selected.disabled || selected.hidden) {
          const allowed = originalOptions.find(function (item) {
            return !item.option.disabled && !item.option.hidden;
          });
          inspiration.value = allowed ? allowed.option.value : '';
        }
      }
      root.querySelectorAll('[data-selected-piece]').forEach(function (element) {
        element.textContent = typeForReview() || emptyLabel;
      });
    }

    function valuesForReview() {
      const budget = selectedText('oc-budget');
      const currency = fieldValue('oc-currency');
      const numericBudget = /\d/.test(fieldValue('oc-budget'));
      return {
        type: typeForReview(),
        inspiration: selectedText('oc-inspiration'),
        finish: selectedRadio('contact[Finish preference]'),
        material: fieldValue('oc-material'),
        stones: selectedText('oc-stones'),
        engraving: fieldValue('oc-engraving'),
        size: fieldValue('oc-size'),
        budget: budget && numericBudget ? [budget, currency].filter(Boolean).join(' — ') : budget,
        idea: fieldValue('oc-idea'),
        reference: fieldValue('oc-reference'),
        name: fieldValue('oc-name'),
        email: fieldValue('oc-email'),
        phone: fieldValue('oc-phone'),
        method: selectedText('oc-contact-method')
      };
    }

    function reviewLabel(key) {
      const output = root.querySelector('[data-review="' + key + '"]');
      if (output && output.dataset.label) return output.dataset.label;
      const term = output && output.previousElementSibling;
      if (term && term.tagName === 'DT' && term.textContent.trim()) return term.textContent.trim();
      const labels = {
        type: 'Jewelry type', inspiration: 'Style inspiration', finish: 'Finish preference',
        material: 'Material preference', stones: 'Stone preference', engraving: 'Engraving preference',
        size: 'Size or dimensions', budget: 'Approximate budget', idea: 'Design idea',
        reference: 'Reference link', name: 'Name', email: 'Email', phone: 'WhatsApp',
        method: 'Preferred contact method'
      };
      return labels[key] || key;
    }

    function updateReview() {
      const values = valuesForReview();
      root.querySelectorAll('[data-review]').forEach(function (output) {
        if (Object.prototype.hasOwnProperty.call(values, output.dataset.review)) {
          output.textContent = values[output.dataset.review] || emptyLabel;
        }
      });
      if (summary) {
        summary.value = '';
        summary.value = Object.keys(values).filter(function (key) {
          return Boolean(values[key]);
        }).map(function (key) {
          return reviewLabel(key) + ': ' + values[key];
        }).join('\n');
      }
    }

    function focusCurrentStep() {
      const panel = panels.find(function (item) { return Number(item.dataset.step) === currentStep; });
      const heading = panel && panel.querySelector('[data-step-title]');
      const target = heading || panel;
      if (!target) return;
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      const reducedMotion = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    }

    function showStep(number, shouldFocus) {
      if (!Number.isInteger(number) || number < 1 || number > 4) return;
      currentStep = number;
      root.dataset.currentStep = String(number);
      panels.forEach(function (panel) {
        const active = Number(panel.dataset.step) === number;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      root.querySelectorAll('[data-step-trigger]').forEach(function (button) {
        const step = Number(button.dataset.stepTrigger);
        button.classList.toggle('is-active', step === number);
        button.classList.toggle('is-current', step === number);
        button.classList.toggle('is-complete', step < number);
        if (step === number) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
      if (progress) {
        progress.textContent = stepLabel.replace(/\{current\}/g, String(number)).replace(/\{total\}/g, '4');
      }
      if (progressBar) {
        progressBar.style.width = String(number / 4 * 100) + '%';
        if (progressBar.getAttribute('role') === 'progressbar') {
          progressBar.setAttribute('aria-valuemin', '1');
          progressBar.setAttribute('aria-valuemax', '4');
          progressBar.setAttribute('aria-valuenow', String(number));
          progressBar.setAttribute('aria-valuetext', progress ? progress.textContent : String(number));
        }
      }
      if (number === 4) updateReview();
      if (shouldFocus) focusCurrentStep();
    }

    function firstInvalid(container) {
      if (phone && container.contains(phone) && root.dataset.phoneError) {
        const value = phone.value.trim();
        const digits = value.replace(/\D/g, '');
        const invalidPhone = value && (!/^\+[0-9 ().-]+$/.test(value) || digits.length < 7 || digits.length > 15);
        phone.setCustomValidity(invalidPhone ? root.dataset.phoneError : '');
      }
      return Array.from(container.querySelectorAll('input, select, textarea')).find(function (field) {
        return field.willValidate && !field.checkValidity();
      });
    }

    function reportInvalid(field) {
      const panel = field.closest('[data-step]');
      if (panel) showStep(Number(panel.dataset.step), false);
      field.reportValidity();
    }

    function navigate(number) {
      if (submitting || !Number.isInteger(number) || number < 1 || number > 4) return;
      if (number > currentStep) {
        for (let step = 1; step < number; step += 1) {
          const panel = panels.find(function (item) { return Number(item.dataset.step) === step; });
          const invalid = firstInvalid(panel);
          if (invalid) {
            reportInvalid(invalid);
            return;
          }
        }
      }
      showStep(number, true);
    }

    root.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      const control = event.target.closest('[data-next], [data-back], [data-edit], [data-step-trigger], [data-start-design]');
      if (!control || !root.contains(control) || control.disabled) return;
      event.preventDefault();
      if (control.hasAttribute('data-start-design')) {
        focusCurrentStep();
      } else if (control.hasAttribute('data-next')) {
        navigate(currentStep + 1);
      } else if (control.hasAttribute('data-back')) {
        navigate(currentStep - 1);
      } else if (control.hasAttribute('data-edit')) {
        navigate(Number(control.dataset.edit));
      } else {
        navigate(Number(control.dataset.stepTrigger));
      }
    });

    form.addEventListener('change', function (event) {
      if (event.target.name === 'contact[Jewelry type]') synchronizeInspiration();
      if (currentStep === 4) updateReview();
    });

    form.addEventListener('input', function (event) {
      if (event.target === phone) phone.setCustomValidity('');
      if (event.target.id === 'oc-other-piece') synchronizeInspiration();
      if (currentStep === 4) updateReview();
    });

    form.addEventListener('submit', function (event) {
      if (submitting) {
        event.preventDefault();
        return;
      }
      if (currentStep < 4) {
        event.preventDefault();
        navigate(currentStep + 1);
        return;
      }
      const invalid = firstInvalid(form);
      if (invalid) {
        event.preventDefault();
        reportInvalid(invalid);
        return;
      }
      synchronizeInspiration();
      updateReview();
      savePendingRequest(form, pendingKey);
      submitting = true;
      form.setAttribute('aria-busy', 'true');
      if (submit) {
        submit.disabled = true;
        if (submit.dataset.submitting && submitLabel) {
          submitLabel.textContent = submit.dataset.submitting;
          submitLabelChanged = true;
        }
      }
    });

    const controller = {
      root: root,
      restore: function () {
        clearPendingRequest(pendingKey);
        submitting = false;
        form.removeAttribute('aria-busy');
        if (submit) submit.disabled = false;
        if (submitLabel && submitLabelChanged) {
          submitLabel.replaceChildren.apply(submitLabel, originalSubmitContent);
          submitLabelChanged = false;
        }
        synchronizeInspiration();
        if (currentStep === 4) updateReview();
      }
    };
    registry.controllers.add(controller);

    synchronizeInspiration();
    const emailError = serverError && (form.dataset.errorField === 'email'
      || serverError.querySelector('[data-error-field="email"], a[href="#oc-email"], a[href="#email"]'));
    showStep(emailError ? 3 : 1, false);
    if (serverError) {
      if (!serverError.hasAttribute('tabindex')) serverError.setAttribute('tabindex', '-1');
      serverError.focus({ preventScroll: true });
    }
  }

  function scan(scope) {
    if (scope instanceof Element && scope.matches('[data-onver-custom]')) initialize(scope);
    if (scope && scope.querySelectorAll) scope.querySelectorAll('[data-onver-custom]').forEach(initialize);
  }

  if (!registry.listenersInstalled) {
    registry.listenersInstalled = true;
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      registry.controllers.forEach(function (controller) {
        if (event.target.contains(controller.root)) registry.controllers.delete(controller);
      });
    });
    window.addEventListener('pageshow', function () {
      registry.controllers.forEach(function (controller) {
        if (controller.root.isConnected) controller.restore();
        else registry.controllers.delete(controller);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }
}());
